import React from 'react';
import styles from './WhiteSpace.css';

const WhiteSpace = () => <div className={styles.space} />;

export default WhiteSpace;



// WEBPACK FOOTER //
// ./src/components/WhiteSpace.jsx